import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import I18n from 'i18n-react';
import { Redirect } from 'react-router-dom';
import { Cookies } from 'react-cookie';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import './Logout.css';
import NavbarService from '../../services/navbar/NavbarService';
import Cookie from '../../const/Cookie';
import LocalStorage from '../../const/LocalStorage';

const DELETE_LOGOUT_V1 = '/platform-session/api/v1/logout/';

const propTypes = {
  display: PropTypes.bool.isRequired,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  className: PropTypes.string,
  callcenterMode: PropTypes.bool
};

class Logout extends React.Component {
  constructor() {
    super();
    this.state = {
      display: false,
      isRedirect: false,
      pathname: '/',
      search: null
    };
  }

  componentWillMount() {
    this.setState({
      display: this.props.display
    });
  }

  componentWillReceiveProps(nextProps) {
    const display = nextProps.display;
    if (display !== this.props.display) {
      this.setState({
        display: display,
        isRedirect: false
      });
    }
  }

  logoutClick = () => {
    if (this.props.callcenterMode) {
      this.logoutCustomerCallcenter();
    } else {
      return fetch(DELETE_LOGOUT_V1, {
        method: 'DELETE',
        headers: new Headers({
          'Content-Type': 'application/json'
        }),
        credentials: 'same-origin'
      })
        .then(res => {
          if (res.ok) {
            this.logout(Cookie.LOGIN_DATA_KEY);
          } else {
            throw new Error('an error occurred while trying to logout');
          }
        })
        .catch(() => {
          this.showError();
        });
    }
  };

  logout = loginDataCookie => {
    this.props.cookies.remove(loginDataCookie);
    NavbarService.toggle('hide');
    this.redirectToHome();
  };

  logoutCustomerCallcenter() {
    localStorage.removeItem(LocalStorage.CUSTOMER_DATA_CALLCENTER);
    NavbarService.toggle('hide');
    this.redirectToHome();
  }

  showError() {
    this.setState({
      isRedirect: false
    });
    this.showModal(I18n.translate('home.msg.error'));
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal = () => {
    this.setState({
      openModal: false
    });
  };

  redirectToHome() {
    this.setState({
      isRedirect: true,
      pathname: '/',
      search: this.props.callcenterMode ? '?callcenter=true' : null
    });
  }

  renderLogout() {
    if (this.state.isRedirect) {
      return (
        <Redirect
          push
          to={{
            pathname: this.state.pathname,
            search: this.state.search
          }}
        />
      );
    } else {
      return (
        <div id="componentLogout" className={`Logout ${this.props.className || ''}`}>
          <Button
            id="btnLogout"
            className="btnLogout"
            ref={c => {
              this.buttonLogout = c;
            }}
            onClick={this.logoutClick}>
            {I18n.translate('components.logout.logoutLabel')}
          </Button>
          <InfoModal
            id="modalLogout"
            message={this.state.messageInfo}
            showModal={this.state.openModal}
            close={this.closeModal}
            ref={c => {
              this.modalLogout = c;
            }}
          />
        </div>
      );
    }
  }

  render() {
    return this.state.display ? this.renderLogout() : null;
  }
}

Logout.propTypes = propTypes;

export default Logout;



// WEBPACK FOOTER //
// ./src/components/logout/Logout.jsx